<template>
  <div class="invitation-card">
    <div class="_33">
      <p>{{ invitation.invitee.username }}</p>
    </div>
    <div class="_33">
      <p>{{ invitation.status | getStatusName }}</p>
    </div>
    <div class="invitations-card-actions">
      <v-btn
        v-if="!loading && ownProfile.id == event.event_host.id"
        @click="deleteInvitation(invitation.id)"
        style="cursor: pointer"
      >
        <v-icon >mdi-close</v-icon>
      </v-btn>
      <TinyLoaderLight v-if="loading" />
    </div>
  </div>
</template>

<script>
import TinyLoaderLight from "@/components/atoms/TinyLoaderLight";
import { getStatusName } from "@/utils";
import { mapState } from "vuex";

export default {
  components: { TinyLoaderLight },
  props: ["invitation"],
  data() {
    return {
      loading: false,
    };
  },
  filters: {
    getStatusName,
  },
  computed: mapState({
    ownProfile: (state) => state.profiles.ownProfile,
    event: (state) => state.events?.currentEvent,
  }),
  methods: {
    async deleteInvitation(invitationId) {
      if (confirm("Delete this invitation ?")) {
        this.loading = true;
        await this.$store.dispatch("deleteInvitation", invitationId).then(() => {
                    this.$store.dispatch("eventDetails", this.event.event_slug);
        this.loading = false;
        });

      }
    },
  },
};
</script>

<style scoped>
.invitation-card {
  margin: 8px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

p {
  margin: 0;
}

.invitations-card-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 80px;
}
.invitations-card-actions i {
  background: red;
  padding: 4px 4px 3px 4px;
  border-radius: 100%;
  color: white !important;
}
.invitations-card-actions .accept i {
  background: pink;
}
</style>